<template>
<div class="metal">
  Metal
</div>
</template>

<script>
export default {
  name: "Metal"
}
</script>

<style scoped>

</style>